module.exports = __webpack_public_path__ + "static/media/twitter-social-media-svgrepo-com (1).b19b6c40.svg";